import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ITEM_ATTRIBUTES } from 'src/testIds';
import { MatCheckbox } from '@angular/material/checkbox';
import { AttributeValueInputComponent } from '../attribute-value-input/attribute-value-input.component';
import { MatOption } from '@angular/material/core';
import { NgFor } from '@angular/common';
import { MatSelect } from '@angular/material/select';
import { TestIdDirective } from '../../directives/test-id.directive';
import { MatInput } from '@angular/material/input';
import { MatFormField, MatLabel } from '@angular/material/form-field';

@Component({
    selector: 'app-edit-attribute-form',
    templateUrl: './edit-attribute-form.component.html',
    standalone: true,
    imports: [ReactiveFormsModule, MatFormField, MatLabel, MatInput, TestIdDirective, MatSelect, NgFor, MatOption, AttributeValueInputComponent, MatCheckbox]
})
export class EditAttributeFormComponent {
  @Input() form: FormGroup;
  testIds = ITEM_ATTRIBUTES;
  valueTypes = [
    { value: 'string', label: 'Text' },
    { value: 'number', label: 'Number' },
    { value: 'boolean', label: 'Yes/No' },
    { value: 'date', label: 'Date' }
  ];

  prompts = [
    { name: 'On Hire', key: 'on_hire' },
    { name: 'Off Hire', key: 'off_hire' },
    { name: 'Delivery', key: 'delivery' },
    { name: 'Collection', key: 'collection' },
    { name: 'Workshop Job Complete', key: 'workshop_job_complete' }
  ];

  constructor() {}
}
